import { useEffect, useRef, useState } from "react"
import { useParams } from "react-router-dom";
import { getMedJournalsRequest } from "../../services/DriverCardService";
import { $api, $file } from "../../api";
import { PDFIcon } from "./assets/PDFIcon";
import { Stack } from "@mui/material";
import { useAppDispatch, useAppSelector } from "../../store/hooks/redux";
import { setMedJournalAwaiting } from "../../slices/AppSlice";
import moment from "moment";

export interface column {
    id: number,
    name?: string,
    sort?: any | false,
    sortMode?: string,
    filter?: any | false,
    value?: any,
    visible?: boolean,
}

const downloadFile = (url: string, filename: string) => {

  const link = document.createElement('a');
  link.setAttribute('href', url);
  link.setAttribute('download', filename);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}
const download = async (url?: string, date?: string) => {
  console.log(url)
  if (!!url) {
      const fileUrl = await $file.get(url);
      const localUrl = URL.createObjectURL(fileUrl.data)
      downloadFile(localUrl, `Журнал медосмотров от ${date}.xlsx`)
  }
}


export const useMedJournalModel = (tabValue: string) => {
    const { reportsApi, medJournalAwaiting } = useAppSelector(state => state.appReducer)
    const [medJournals, setMedJournals] = useState<any[] | null>([])
    const dispatch = useAppDispatch();
    const [openModal, setOpenModal] = useState<boolean>(false)

    const { curPage } = useParams();
    const [page, setPage] = useState<number>(1)
    const [pageQty, setPageQty] = useState(0);
    const [perPage, setPerPage] = useState<number>(50)

    const [filterRequest, setFilterRequest] = useState<Object>({})
    const [sortingRequest, setSortingRequest] = useState<Object>({})

    const getMedJournalsReports = async () => {
        try {
          getMedJournalsRequest(
            reportsApi.baseUrl.slice(0, -3),
            {page: page, per_page: perPage, ...filterRequest, ...sortingRequest}
          ).then((result) => {
            setMedJournals(result?.data.data)
            setPageQty(result?.data.last_page)
          })
        } catch (e) {
          console.log(e)
        }
    }

    useEffect(() => {
        if (!!curPage) {
            setPage(Number(curPage))
         } else setPage(1);
    }, [curPage])

    useEffect(() => {
      if (page && perPage && reportsApi) {
        getMedJournalsReports()
      }
    }, [page, perPage, filterRequest, sortingRequest, reportsApi])

    const changePage=(num:any)=>{
        setPage(num)
    }

    // const intervalRef = useRef<any>()

    // useEffect(() => {
    //   if (medJournalAwaiting !== null) {
    //     if (medJournalAwaiting?.interval === null) {
    //       intervalRef.current = setInterval(() => {
    //         getMedJournalsReports(medJournalAwaiting.api, {page: 1, per_page: 5}).then((response) => {
    //           const file_url = response?.data.data.find((item: any) => item.id === medJournalAwaiting.id).file_url
    //           if (file_url) {
    //             console.log(file_url)
    //             // clearInterval(medJournalAwaiting.interval)
    //             clearInterval(intervalRef.current)
    //             setOpenModal(true)
    //             dispatch(setMedJournalAwaiting(null))
    //             getMedJournalsReports(reportsApi.api_url.slice(0, -3), {page: page, per_page: perPage, ...filterRequest, ...sortingRequest}).then((response) => {
    //               setMedJournals(response?.data.data)
    //               setPageQty(response?.data.last_page)
    //             })
    //           }
    //         })
    //       }, 6000)
    //       dispatch(setMedJournalAwaiting({...medJournalAwaiting, interval: intervalRef.current}))
    //     } else if (tabValue === 'MED_JOURNAL') {
    //       getMedJournalsReports(medJournalAwaiting.api, {page: 1, per_page: 5}).then((response) => {
    //         const file_url = response?.data.data.find((item: any) => item.id === medJournalAwaiting.id).file_url
    //         if (file_url) {
    //           console.log(file_url)
    //           // clearInterval(medJournalAwaiting.interval)
    //           clearInterval(intervalRef.current)
    //           setOpenModal(true)
    //           dispatch(setMedJournalAwaiting(null))
    //           getMedJournalsReports(reportsApi.api_url.slice(0, -3), {page: page, per_page: perPage, ...filterRequest, ...sortingRequest}).then((response) => {
    //             setMedJournals(response?.data.data)
    //             setPageQty(response?.data.last_page)
    //           })
    //         }
    //       })
    //     }
    //   }
    // }, [tabValue, medJournalAwaiting])


    const setSortMode = (id: number, mode: string) => {
        setColumns((prev) => prev.map((col) => col.id === id ? {...col, sortMode: mode} : {...col, sortMode: ''} ))
      }

      const [openViewSettings, setOpenViewSettings] = useState<boolean>(false)

      const [columns, setColumns] = useState<column[]>([
          { 
            id: 1,
            name: '№', 
            sort: false,
            sortMode: '',
            filter: false,
            value: (row: any) => (row.id),
            visible: true,
          },
          { 
            id: 2,
            name: 'Дата запроса', 
            sort: false,
            sortMode: '',
            filter: false, 
            value: (row: any) => (row?.requestedAt ? moment.tz(row.requestedAt, 'Europe/Moscow').format('DD.MM.YYYY HH:mm') : '-'),
            visible: true,
          },
          { 
            id: 2,
            name: 'Дата формирования', 
            sort: false,
            sortMode: '',
            filter: false, 
            value: (row: any) => (row?.generatedAt ? moment.tz(row.generatedAt, 'Europe/Moscow').format('DD.MM.YYYY HH:mm') : ' - '),
            visible: true,
          },
          {
            id: 4,
            name: 'ФИО',
            sort: false,
            sortMode: '',
            filter: false,
            value: (row: any) => row?.requstedByFio,
            visible: true,
          },
          { 
            id: 6,
            name: 'Медицинский журнал', 
            sort: false,
            sortMode: '',
            filter: false,
            value: (row: any) => row?.file_url ? (
              <Stack style={{cursor: 'pointer', flexDirection: 'row', alignItems: 'center', gap: '3px'}}
                onClick={()=>{download(row?.file_url, moment.tz(row.generatedAt, 'Europe/Moscow').format('DD.MM.YYYY'))}} 
              >
                <a href='javascript:;' style={{color: '#009FDA'}}>Скачать</a>
              </Stack>
            ) : 'Формируется...',
            visible: true,
          },
    ])


    return {
        medJournals,
        page,
        pageQty,
        changePage,

        openViewSettings,
        setOpenViewSettings,
        columns,
        setColumns,
        setFilterRequest,

        filterRequest,
        sortingRequest,
        
        perPage,
        setPerPage,
        reportsApi,
        openModal,
        setOpenModal,
        medJournalAwaiting,
        getMedJournalsReports,
    }
}